import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=011323d6&"
import script from "./loading-overlay.vue?vue&type=script&lang=js&"
export * from "./loading-overlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports